var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOntapDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0167c5",
    fillRule: "evenodd",
    d: "M18 40.385h9.335V28.754h5.329v11.631H42V21H18z",
    transform: "translate(2 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntapDefault);
export default __webpack_public_path__ + "static/media/ontap-default.96badac6d20d83a448b99570a0383417.svg";
export { ForwardRef as ReactComponent };